import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import moment from 'moment';
import VueScrollTo from 'vue-scrollto';
import { mask } from 'vue-the-mask'
import './scss/app.scss'
import './scss/main.scss'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
// import 'aos/dist/aos.css';

import lazy from "./directives/lazy-load";
import {BButton, BIcon, BInput, BCheckbox, BModal, BTextArea, BPagination} from './components/elements';
import ClickOutsideDirective from './directives/click-outside';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faPaperPlane, faPlane, faRocket, faTimes, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faTwitter, faInstagram } from '@fortawesome/free-brands-svg-icons'
library.add(
    faPaperPlane, faPlane, faRocket, faTimes, faArrowRight,
    faFacebookF, faTwitter, faInstagram
);

const app = createApp(App)

app.component('font-awesome-icon', FontAwesomeIcon);
app.component('b-button', BButton);
app.component('b-icon', BIcon);
app.component('b-input', BInput);
app.component('b-checkbox', BCheckbox);
app.component('b-modal', BModal);
app.component('b-textarea', BTextArea);
app.component('b-pagination', BPagination);

app.config.globalProperties.$moment = moment;
app.directive('lazy', lazy);
app.directive('click-outside', ClickOutsideDirective);
app.directive('mask', mask);

app.use(router);
app.use(store);
app.use(VueScrollTo, {
  container: "body",
  duration: 1500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});

app.mount('#app')
